import React from 'react';
import { usePromotions } from '../../hooks/usePromotions';
import UpgradePrompt from './UpgradePrompt';
import SpecialOfferBanner from './SpecialOfferBanner';

export default function PromotionManager() {
  const { showPrompt, showBanner, handleClose } = usePromotions();

  return (
    <>
      {showPrompt && <UpgradePrompt onClose={handleClose} />}
      {showBanner && <SpecialOfferBanner onClose={handleClose} />}
    </>
  );
}